/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Blog_Seo_DescriptionInputs */

const en_marketing_blog_seo_description = /** @type {(inputs: Marketing_Blog_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes from building Onyx: architecture decisions, Cloudflare patterns, and what shipping on a typed foundation actually looks like.`)
};

const es_marketing_blog_seo_description = /** @type {(inputs: Marketing_Blog_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas sobre la creación de Onyx: decisiones de arquitectura, patrones de Cloudflare y cómo es realmente lanzar sobre una base tipada.`)
};

const fr_marketing_blog_seo_description = /** @type {(inputs: Marketing_Blog_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes sur la construction d'Onyx : décisions d'architecture, motifs Cloudflare et ce que livrer sur une fondation typée veut vraiment dire.`)
};

/**
* | output |
* | --- |
* | "Notes from building Onyx: architecture decisions, Cloudflare patterns, and what shipping on a typed foundation actually looks like." |
*
* @param {Marketing_Blog_Seo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_blog_seo_description = /** @type {((inputs?: Marketing_Blog_Seo_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Blog_Seo_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_blog_seo_description(inputs)
	if (locale === "es") return es_marketing_blog_seo_description(inputs)
	return fr_marketing_blog_seo_description(inputs)
});